function About() {
  return (
    <div className="container mx-auto px-4 lg:px-0 py-8">
      <h2 className="text-3xl lg:text-4xl font-bold mb-6">
        Welcome to Our Store
      </h2>
      <p className="text-lg lg:text-xl mb-6">
        We offer the latest and greatest electronics at affordable prices, and
        our team of experts carefully selects each product in our store.
      </p>
      <p className="text-lg lg:text-xl mb-6">
        Our mission is to provide our customers with a wide range of
        high-quality electronics at affordable prices. We believe that everyone
        should have access to the latest technology, and we're dedicated to
        making that a reality.
      </p>
      <h2 className="text-3xl lg:text-4xl font-bold mb-6">
        Our Promise to You
      </h2>
      <p className="text-lg lg:text-xl mb-6">
        At our store, we stand behind every product we sell. We're committed to
        providing our customers with high-quality products that meet their needs
        and exceed their expectations.
      </p>
      <p className="text-lg lg:text-xl mb-6">
        If for any reason you're not completely satisfied with your purchase,
        we'll do everything we can to make it right. We value your trust and are
        committed to providing a safe and secure shopping experience.
      </p>
    </div>
  );
}

export default About;
